export const broochDict = {
  "None": {
    bonus: 0.00,
    slots: 0
  },
  "T1": {
    bonus: 0.10,
    slots: 0
  },
  "T2": {
    bonus: 0.25,
    slots: 0
  },
  "T3": {
    bonus: 0.50,
    slots: 0
  },
  "T3R": {
    bonus: 0.60,
    slots: 1
  },
  "T3E": {
    bonus: 0.70,
    slots: 2
  },
  "T4": {
    bonus: 1.00,
    slots: 0
  },
  "T4R": {
    bonus: 1.25,
    slots: 1
  },
  "T4E": {
    bonus: 1.50,
    slots: 2
  },
  "T4L": {
    bonus: 2.00,
    slots: 3
  },
};

export const medallionDict = {
  "None": {
    bonus: 0.00,
    slots: 0
  },
  "T1": {
    bonus: 0.10,
    slots: 0
  },
  "T2": {
    bonus: 0.25,
    slots: 0
  },
  "T2R": {
    bonus: 0.30,
    slots: 1
  },
  "T3": {
    bonus: 0.50,
    slots: 0
  },
  "T3E": {
    bonus: 0.60,
    slots: 2
  },
  "T4": {
    bonus: 1.00,
    slots: 0
  },
  "T4R": {
    bonus: 1.10,
    slots: 1
  },
  "T4E": {
    bonus: 1.20,
    slots: 2
  },
  "T4L": {
    bonus: 1.30,
    slots: 3
  },
};

export const monocleBonusDict = {
  "None": 0.00,
  "T1": 0.05,
  "T2": 0.10,
  "T3": 0.15,
  "T4": 0.20,
  "T4E": 0.25,
  "T4L": 0.30,
}

export const chaliceBonusDict = {
  "None": 0.00,
  "T1": 0.05,
  "T2": 0.10,
  "T2E": 0.15,
  "T3": 0.20,
  "T3R": 0.23,
  "T3E": 0.25,
  "T4": 0.30,
  "T4E": 0.35,
  "T4L": 0.40,
}

export const beakGeChanceDict = {
  "None": 0.30,
  "T1": 0.36,
  "T2": 0.45,
  "T3": 0.60,
  "T3R": 0.90,
  "T4 (any)": 1.00,
  "T3R w/ T2 Clarity": 0.45,
  "T3R w/ T3 Clarity": 0.60,
  "T4R or T4L w/ any Clarity": 1.00,
};